import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@/lib/utils';

/**
 * THE app's tooltip: every hover hint, in both editions, is one of these
 * (user, 2026-09-26: "all popovers in the app should use that"). Never the
 * native `title` attribute, which the browser draws late, in its own style,
 * and never on touch. Wrap the element in Tooltip / TooltipTrigger asChild /
 * TooltipContent; a component that does not forward its ref goes inside a
 * span. The one TooltipProvider is mounted at the root (main.tsx); tests wrap
 * in their own.
 */
const TooltipProvider = TooltipPrimitive.Provider;

/** How long the pointer rests before a tooltip opens: the provider's, and any tooltip opened by hand. */
export const TOOLTIP_DELAY_MS = 300;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'z-50 overflow-hidden rounded-md bg-primary px-2.5 py-1 text-xs text-primary-foreground shadow-md',
        className,
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
